import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { data } from '../../evn/evn'; // Ensure the correct path
import Sidebar from '../AdminComponents/SideBar';
import styles from './ChatManagement.module.css'; // Adjust the path as needed

const ChatManagement = () => {
  const [chats, setChats] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchType, setSearchType] = useState('id');
  const navigate = useNavigate();


  useEffect(() => {
    const fetchChats = async () => {
      const ip = data.evn;
      const token = localStorage.getItem('adminToken');
      if (!token) {
        navigate('/.admin');
        return false;
    }
      

      try {
        const response = await axios.get(`${ip}/admin/chats`, {
          headers: { 'x-auth-token': token },
        });
        setChats(response.data.chats);
        setSearchResults(response.data.chats);
      } catch (error) {
        console.error("There was an error fetching the chats:", error);
      }
    };

    fetchChats();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    if (!event.target.value) {
      setSearchResults(chats);
    } else {
      const filteredChats = chats.filter(chat => {
        switch (searchType) {
          case 'id':
            return chat.id.toString().includes(event.target.value);
          case 'user1_id':
            return chat.user1_id.toString().includes(event.target.value);
          case 'user2_id':
            return chat.user2_id.toString().includes(event.target.value);
          default:
            return false;
        }
      });
      setSearchResults(filteredChats);
    }
  };

  const handleSearchTypeChange = (event) => {
    setSearchType(event.target.value);
    setSearchTerm('');
    setSearchResults(chats);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && searchTerm) {
      const exactMatchChats = chats.filter(chat => {
        switch (searchType) {
          case 'id':
            return chat.id.toString() === searchTerm;
          case 'user1_id':
            return chat.user1_id.toString() === searchTerm;
          case 'user2_id':
            return chat.user2_id.toString() === searchTerm;
          default:
            return false;
        }
      });
      setSearchResults(exactMatchChats);
    }
  };

  return (
    <>
      <Sidebar />
      <div className={styles.container}>
        <div className={styles.searchContainer}>
          <select
            className={styles.searchTypeSelect}
            value={searchType}
            onChange={handleSearchTypeChange}
          >
            <option value="id">Search by Chat ID</option>
            <option value="user1_id">Search by User1 ID</option>
            <option value="user2_id">Search by User2 ID</option>
          </select>
          <input
            type="text"
            placeholder={`Search by ${searchType}...`}
            value={searchTerm}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
            className={styles.searchInput}
          />
        </div>
        <table className={styles.table}>
          <thead>
            <tr className={styles.tableRow}>
              <th className={styles.tableHeader}>Chat ID</th>
              <th className={styles.tableHeader}>User1 ID</th>
              <th className={styles.tableHeader}>User2 ID</th>
            </tr>
          </thead>
          <tbody>
            {searchResults.map((chat) => (
              <tr key={chat.id} className={styles.tableRow}>
                <td className={styles.tableCell}>{chat.id}</td>
                <td className={styles.tableCell}>{chat.user1_id}</td>
                <td className={styles.tableCell}>{chat.user2_id}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ChatManagement;
